import * as React from "react";
import { useSelector } from "react-redux";

function SvgSearch(props) {
  const { isDarkTheme } = useSelector(({ common }) => common);
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={11.63} height={11.639} {...props}>
        <path
          d="M4.972 0A4.977 4.977 0 000 4.972a4.977 4.977 0 004.972 4.967 4.975 4.975 0 003.128-1.1l2.65 2.65a.514.514 0 00.363.15.513.513 0 00.365-.151.513.513 0 00.151-.365.513.513 0 00-.151-.365L8.829 8.109a4.985 4.985 0 001.115-3.137A4.978 4.978 0 004.972 0zm0 9.013A4.028 4.028 0 013.4 8.696a4.045 4.045 0 01-1.286-.867 4.025 4.025 0 01-.867-1.285 4.012 4.012 0 01-.316-1.572 4.043 4.043 0 01.316-1.573 4.038 4.038 0 01.867-1.285A4.02 4.02 0 013.4 1.248 4.012 4.012 0 014.972.931a4.036 4.036 0 011.573.317 4.045 4.045 0 011.285.867 4 4 0 01.87 1.284 4 4 0 01.317 1.572A4.028 4.028 0 018.7 6.544a4.033 4.033 0 01-.87 1.285 4.062 4.062 0 01-1.285.867 4.021 4.021 0 01-1.573.317z"
          fill={isDarkTheme ? "#f0ffff" : "#3c4252"}

        />
      </svg>
    </span>
  );
}

export default SvgSearch;
